import ActivityManager from "@/activity/ActivityManager";
import ActivityWorkspace from "@/activity/ActivityWorkspace";
import FormsActions from "@/components/forms/FormsActions";
import Product from "@/server/com/silkplm/model/plm/Product";
import SimpleForm from "@/server/com/silkplm/model/healthcheck/SimpleForm";
import Events from "@/utils/Events";
import EventBus from "@/utils/EventBus";

function triggerMouseEvent (node, eventType) {
    let rect = node?.getClientRects?.()[0];
    let clickEvent = new MouseEvent(eventType, {clientX : rect?.x, clientY: rect?.y, bubbles:true, cancelable:true});
    node.dispatchEvent (clickEvent);
}

function elementEnabled(targetNode){
    return targetNode && !targetNode.disabled && targetNode.style['pointer-events'] !== "none";
}

async function sleep(tm){
    return new Promise(resolve => {
        setTimeout(resolve, tm);
    })
}

function emulateClick(targetNode){
    triggerMouseEvent (targetNode, "mouseover");
    setTimeout(()=>{
        let activeElement = document.activeElement;
        setTimeout(()=> {
            triggerMouseEvent(targetNode, "mousedown");
            setTimeout(()=> {
                let eventToRun = new FocusEvent("focus", {relatedTarget: activeElement});
                targetNode.dispatchEvent(eventToRun);
                setTimeout(()=> {
                    triggerMouseEvent(targetNode, "mouseup");
                    triggerMouseEvent(targetNode, "click");
                })
            })
        })
    })
}

async function emulateSelectByText(xPathSelect, xPathOptionToSelect) {
    console.log(`Emulating select ${xPathSelect} ==> ${xPathOptionToSelect}`)
    return await emulateSelect(evalXpath(xPathSelect), evalXpath(xPathOptionToSelect).value);
}

async function emulateSelect(targetNode, val){
    let attempt = 0;
    while(attempt < 100) {
        if(attempt > 0){
            await new Promise((resolve) => setTimeout(resolve, 50));
        }

        attempt++;

        const options = targetNode.options;

        let valueByText = null;
        let valueFound = null;
        let byText = 0;
        let byValue = 0;

        for (let i = 0; i < options.length; i++) {
            if (val === options[i].value) {
                valueFound = val;
                byValue++;
            }
            if (options[i].text === val) {
                valueByText = options[i].value;
                byText++
            }
        }
        let effectiveValue = null;
        if (byValue) {
            if (byValue > 1) {
                console.error(`Duplicate value ${valueFound} on select list: \n` + targetNode.innerHTML);
            }
            effectiveValue = valueFound;
        } else if (byText) {
            if (byText > 1) {
                console.error(`Duplicate texts ${valueFound} on select list: ` + targetNode.innerHTML);
            }

            console.log(`Selecting entry in Select by text ${val} --> ${valueByText}`);
            effectiveValue = valueByText;
        } else {
            console.log(`No value nor text found in select ${val} (waiting 50ms)`);
            continue;
        }

        console.log(`Setting select value to effectiveValue: ${effectiveValue}`);

        return await new Promise(resolve => {
            setTimeout(() => {
                emulateClick(targetNode);
                setTimeout(() => {
                    targetNode.focus();
                    setTimeout(() => {
                        targetNode.value = effectiveValue;
                        setTimeout(() => {
                            targetNode.dispatchEvent(new Event("change"));
                            setTimeout(() => {
                               resolve();
                            });
                        });
                    });
                });
            });
        });

        break;
    }
}

function topActivityType(){
    let activity = ActivityManager.getTopActivity();
    if (!activity){
        return null;
    }
    let model = ActivityManager.workspace._findActivityModel(activity);
    return model.componentName;
}

function topActivityTitle(){
    let activity = ActivityManager.getTopActivity();
    return activity?.getTitle()
}

export function evalXpath(path) {
    return document.evaluate(path, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE).singleNodeValue;
}
export function evalXpathAll(path){

    const result = document.evaluate(
        path,           // XPath expression
        document,                  // Context node (the entire document)
        null,                      // Namespace resolver (null for HTML)
        XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, // Result type
        null                       // Result object (null to create a new one)
    );

    for (let i = 0; i < result.snapshotLength; i++) {
        const node = result.snapshotItem(i);
        console.log(`Node ${i + 1}:`, node);
    }
}

export async function waitForRpcEnd(){
    let attempts = 0;
    while(window._rpcInProgress){
        attempts++;
        console.log(`Waiting for rpc ${attempts}`)
        await new Promise(resolve=>setTimeout(resolve, 10));
    }
    console.log("waitForRpcEnd TIMEOUT");
}

export async function isRpcInProgress(){
    return window._rpcInProgress;
}

export function setupTestHelpers(){
    window._rpcInProgress = false;
    EventBus.$on(Events.rpcStart, () => {
        window._rpcInProgress = true;
    });
    EventBus.$on(Events.rpcEnd, () => {
        EventBus.vue.$nextTick(()=>{
            setTimeout(() => {
                window._rpcInProgress = false;
            }, 1);
        })
    });

    window.emulateClick = emulateClick;
    window.elementEnabled = elementEnabled;
    window.triggerMouseEvent = triggerMouseEvent;
    window.topActivityType = topActivityType;
    window.topActivityTitle = topActivityTitle;
    window.emulateSelect = emulateSelect;
    window.emulateSelectByText = emulateSelectByText;
    window.waitForRpcEnd = waitForRpcEnd;
    window.isRpcInProgress = isRpcInProgress;
    window.evalXpathAll = evalXpathAll;
    window.sleep = sleep;
}

window.evalXpath = evalXpath;
window._testMultiSelect = async function(){
    let products = await (await FormsActions.showMultiSelectList(Product, {
        showAdd: false,
        showDelete: false,
        formTitle: "Assign Products to Season: Products",
        showImport: false,
        showExport: false
    }, [])).getResult();
}

window._genSimpleForms = async function(){
    for(let i=0; i< 100; i++){
        let sf = new SimpleForm().withTestInt(i + (new Date().getTime() - 1700465504309));
        await sf.save();
    }
    console.log("Complete");
}
